import React, { Component } from "react";
import {
  Textbox,
  Textarea,
  Radiobox,
  Checkbox,
  Select,
} from "react-inputs-validation";
import axios from './../Api/MainApi';
import MethodsTwoContext from './../Contexts/MethodsTwo';
// import "react-inputs-validation/lib/react-inputs-validation.min.css";
// import "../Other/Validation/styles_Validate.css";
import { COUNTRY_OPTIONS_LIST, JOB_OPTIONS_LIST } from "../Other/Validation/consts_Validation.js";
import { Route, Link } from "react-router-dom";
import logger from './../Tools/Log';
import lang from './../Tools/Lang';
import LoadingOverlay from 'react-loading-overlay';
import ScrollAnimation from 'react-animate-on-scroll';  

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      email: "",
      password: "",
      hasEmailError: true,
      hasPasswordError: true,
      validate: false,
      extraValidate: false,
      error:''
    };
    this.validateForm = this.validateForm.bind(this);
  }
  

  static contextType = MethodsTwoContext; 
  firstLoad = true;

  
  loginUser(){
       this.getToken();
   }

  toggleValidating(validate) {
    this.setState({ validate });
   }

  validateForm(e) {
    e.preventDefault();
    this.toggleValidating(true);
    this.state.extraValidate = true;

    // const {
    //   hasEmailError,
    //   hasPasswordError,
    //   validate
    // } = this.state;

    // logger('Route>>Login>>validateForm>>',this.state);

    // if (
    //   !hasEmailError &&
    //   !hasPasswordError 
    //   // &&
    //   // !this.firstLoad 

    // ) {
    //   this.loginUser();        
    // }

    // this.firstLoad = false;
  }

  googleLogin(){

  }

  getToken(){

    var reqData = {
      username:this.state.email,
      password:this.state.password,
      grant_type: 'password'}

      logger('Route>>Login>>getToken>>',reqData);

    var queryString = Object.keys(reqData).map(function(key) {
                           return encodeURIComponent(key) + '=' + encodeURIComponent(reqData[key])
                      }).join('&');
     this.setState({loading:true});  
      axios.post(`/oauth/token`,queryString)
    .then(Response =>{
      this.context.authorizationInfo.setState({accessToken : 'Bearer ' + Response.data.access_token,
                                               username : this.state.email})
       this.setState({loading:false});                                        
       window.location.href = window.location.origin ;
    })
    .catch(err => {
      this.setState({loading:false});  
      try {
        this.setState({error : err.response.data.error});
      } catch (error) {
        this.setState({error : lang.getStr('error_connction')});
      }
         
    })

}

componentDidUpdate(){
  const {
    hasEmailError,
    hasPasswordError,
    extraValidate
  } = this.state;
  logger('Route>>Login>>componentDidUpdate>>hasEmailError>>',hasEmailError);
  logger('Route>>Login>>componentDidUpdate>>hasPasswordError>>',hasPasswordError);
  logger('Route>>Login>>componentDidUpdate>>extraValidate>>',extraValidate);
  if (
      !hasEmailError &&
      !hasPasswordError &&
       extraValidate ) {
          this.state.extraValidate = false;
          this.loginUser();        
       }
}

  googleRegiter(){
    
  }

  render() {
    const {
      email,
      password,
      validate
    } = this.state;


    return (
      <>
             <LoadingOverlay
                active={this.state.loading}
                spinner
                text='لطفا صبور باشید...'
                >
      <div class="register_panel login_panel">
      <ScrollAnimation animateIn="fadeIn">
          <div class="container">
              <div class="register-myself" >
                    <form onSubmit={this.validateForm} class="form form-myself" >
                                <div class="form-body">
                                <div class="register-section">                          
                                  <span class="label">{lang.getStr('registerCom1')}</span>
                                  <Link to="/register?plan=0" class="btn btn-info">ایجاد حساب کاربری</Link></div>
                                    <div class="form-group">
                                       <label htmlFor="panel" class="label-control label-control-extra">{lang.getStr('registerCom2')}</label>  
                                       <div style={{color:'red', marginBottom:10}}>{lang.getStr(this.state.error,"ورود با مشکل روبه روشد") }</div>                            
                                       <Textbox
                                              attributesInput={{
                                                id: "email",
                                                name: "email",
                                                type: "text",
                                                placeholder: "ایمیل خود را وارد کنید."
                                              }}
                                              value={email} 
                                              disabled={false}
                                              validate={validate} 
                                              validationCallback={res =>
                                                {
                                                this.setState({ hasEmailError: res, validate: false })
                                                this.state.hasEmailError = res
                                                this.state.validate = false}
                                              } 
                                              classNameInput="form-control" 
                                              classNameWrapper="wrapper-extra" 
                                              onChange={(email, e) => {
                                                this.setState({ email });
                                                console.log(e);
                                              }} 

                                              validationOption={{
                                                name: "email", 
                                                check: true, 
                                                required: true, 
                                                msgOnError: <span class='form-error active'><strong>فیلد ایمیل الزامی است</strong></span>, 
       
                                              }}
                                            />
                                        </div>
                                    <div class="form-group">    
                                    <Textbox
                                              attributesInput={{
                                                id: "password",
                                                name: "password",
                                                type: "password",
                                                placeholder: "پسورد خود را وارد کنید."
                                              }}
                                              value={password} 
                                              disabled={false}
                                              validate={validate} 
                                              validationCallback={res =>
                                                {
                                                this.setState({ hasPasswordError: res, validate: false })
                                               this.state.hasPasswordError = res
                                                  this.state.validate = false}
                                              } 
                                              // classNameInput={`form-control ${this.state.haspasswordError ? ' has-error' : ''}`}
                                             classNameInput="form-control" 
                                              classNameWrapper="wrapper-extra" 
                                              onChange={(password, e) => {
                                                this.setState({ password });
                                                console.log(e);
                                              }} 

                                              validationOption={{
                                                name: "password", 
                                                check: true, 
                                                required: true, 
                                                msgOnError: <span class='form-error active'><strong>فیلد پسورد الزامی است</strong></span>, 
       
                                              }}
                                            />   
                                         
                                        </div>
                                        <div class="form-group w-25">
                                        {/* <button type='button'  id='btnGetUser' onClick={this.getUser.bind(this)}  class="btn btn-info">
                                           دریافت یوزر
                                          </button> */}
                                          {/* <button type='button'  id='btnGetToken' onClick={this.getToken.bind(this)}  class="btn btn-info">
                                           دریافت توکن
                                          </button>
                                          <button type='button' value='لاگین گوگل' id='btnGoogleLogin' onClick={this.googleLogin}  class="btn btn-info">
                                          لاگین گوگل
                                          </button>
                                          <button type='button' value='' onClick={this.googleRegiter} class="btn btn-info">
                                          ثبت نام گوگل
                                          </button> */}
                                          <button type="submit" id="submit_button" class="btn btn-info">ورود</button>
                                          
                                        </div>
                                </div>
                    </form>
              </div>
          </div>
    
      {/* </div> */}
      </ScrollAnimation>
      </div>
      </LoadingOverlay>
      </>
    );
  }
}

export default App;


